import { CategoriaInvitado, TipoEvento } from "../interfaces/TipoEvento"

export interface TipoEventoTheme {
  calendario: string
  border: string
  card: string
  cardHover: string
  labelSingular: string
  labelPlural: string
  descripcion: string
}

export const TIPO_EVENTO_THEME: Record<TipoEvento, TipoEventoTheme> = {
  [TipoEvento.EGRESADOS]: {
    calendario: "#e3f2fd",
    border: "#6699cc",
    card: "#e3f2fd",
    cardHover: "#d4eaf8",
    labelSingular: "Egresado",
    labelPlural: "Egresados",
    descripcion: "Egresados",
  },
  [TipoEvento.CUMPLEANIOS_BODAS]: {
    calendario: "#ffe0b2",
    border: "#ffaa55",
    card: "#fff3e0",
    cardHover: "#fde8c8",
    labelSingular: "Invitado",
    labelPlural: "Invitados",
    descripcion: "Cumpleaños / Bodas",
  },
  [TipoEvento.FIESTAS]: {
    calendario: "#c8e6c9",
    border: "#66bb6a",
    card: "#e8f5e9",
    cardHover: "#d8eeda",
    labelSingular: "Invitado",
    labelPlural: "Invitados",
    descripcion: "Fiestas",
  },
}

export function getThemeByTipo(
  tipo: TipoEvento | string | undefined,
): TipoEventoTheme {
  return (
    TIPO_EVENTO_THEME[tipo as TipoEvento] ??
    TIPO_EVENTO_THEME[TipoEvento.EGRESADOS]
  )
}

export function getLabelSingular(
  tipo: TipoEvento | string | undefined,
): string {
  return getThemeByTipo(tipo).labelSingular
}

export function getLabelPlural(tipo: TipoEvento | string | undefined): string {
  return getThemeByTipo(tipo).labelPlural
}

export function getDescripcion(tipo: TipoEvento | string | undefined): string {
  return getThemeByTipo(tipo).descripcion
}

export function labelInvitado(tipo: TipoEvento | string | undefined): string {
  return tipo === TipoEvento.EGRESADOS ? "Egresado" : "Invitado"
}

export interface EgresadoFieldConfig {
  dniMostrar: boolean
  dniRequerido: boolean
  telefonoMostrar: boolean
  emailMostrar: boolean
  tarjetasMayores: boolean
  tarjetasBaile: boolean
  menuMesa: boolean
}

export function getFieldConfig(
  tipo: TipoEvento | string | undefined,
  categoria: CategoriaInvitado,
): EgresadoFieldConfig {
  const esBaile = categoria === CategoriaInvitado.BAILE
  if (tipo === TipoEvento.EGRESADOS) {
    return esBaile
      ? { dniMostrar: true,  dniRequerido: false, telefonoMostrar: true, emailMostrar: false, tarjetasMayores: false, tarjetasBaile: true,  menuMesa: false }
      : { dniMostrar: true,  dniRequerido: true,  telefonoMostrar: true, emailMostrar: true,  tarjetasMayores: true,  tarjetasBaile: false, menuMesa: true  }
  }
  if (tipo === TipoEvento.CUMPLEANIOS_BODAS) {
    return esBaile
      ? { dniMostrar: false, dniRequerido: false, telefonoMostrar: true, emailMostrar: false, tarjetasMayores: false, tarjetasBaile: true,  menuMesa: false }
      : { dniMostrar: false, dniRequerido: false, telefonoMostrar: true, emailMostrar: false, tarjetasMayores: true,  tarjetasBaile: false, menuMesa: true  }
  }
  // FIESTAS / default
  return   { dniMostrar: true,  dniRequerido: false, telefonoMostrar: true, emailMostrar: true,  tarjetasMayores: true,  tarjetasBaile: false, menuMesa: true  }
}
